module.exports = __webpack_public_path__ + "img/qrcode.27221056.jpg";